import { getLocalStorageInfo } from "../../utils_v2"
import config from '../../config';

export const halcyonInstance = [484].includes(getLocalStorageInfo()?.defaultLessor?.id);
export const titanInstance = [480, 446].includes(getLocalStorageInfo()?.defaultLessor?.id);
export const gaTelesisInstance = [498].includes(getLocalStorageInfo()?.defaultLessor?.id);
export const avationPlcInstance = [504].includes(getLocalStorageInfo()?.defaultLessor?.id);
export const testLessor = getLocalStorageInfo()?.defaultLessor?.id === 13;
export const Lessor_test = getLocalStorageInfo()?.defaultLessor?.id ===446;
export const mtInstance = [519].includes(getLocalStorageInfo()?.defaultLessor?.id);
export const leshaBankInstance = [496,510].includes(getLocalStorageInfo()?.defaultLessor?.id);
export const regionalOneInstance = [242].includes(getLocalStorageInfo()?.defaultLessor?.id);
export const hanwahaInstance = [483].includes(getLocalStorageInfo()?.defaultLessor?.id);


